export default function PHP_Access_Array_Items() {
  return (
    <div>
      <h1>PHP_Access_Array_Items</h1>
    </div>
  );
}
